import SiteHeader from "./components/SiteHeader";
import Hero from "./components/Hero";
import FocusFeed from "./components/FocusFeed";
import CategoryZones from "./components/CategoryZones";
import ArchiveTimeline from "./components/ArchiveTimeline";
import DeepDive from "./components/DeepDive";
import HotRank from "./components/HotRank";
import TrustFaq from "./components/TrustFaq";
import Cta from "./components/Cta";
import SiteFooter from "./components/SiteFooter";
import Reveal from "./components/Reveal";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900 font-sans">
      <SiteHeader />
      <main>
        <Reveal>
          <Hero />
        </Reveal>
        <Reveal>
          <FocusFeed />
        </Reveal>
        <Reveal>
          <CategoryZones />
        </Reveal>
        <Reveal>
          <ArchiveTimeline />
        </Reveal>
        <Reveal>
          <DeepDive />
        </Reveal>
        <Reveal>
          <HotRank />
        </Reveal>
        <Reveal>
          <TrustFaq />
        </Reveal>
        <Reveal>
          <Cta />
        </Reveal>
      </main>
      <SiteFooter />
    </div>
  );
}